// src/AppRoutes.js
import { Routes, Route, Navigate } from "react-router-dom";

// Single-file layout from pages/Home.js (Navbar + <Outlet/>)
import AppLayout, { Home } from "./pages/Home";

// Public pages
import AboutUs from "./pages/AboutUs";
import ApplyMembership from "./pages/ApplyMembership";
import MemberLogin from "./pages/MemberLogin";
import MemberDashboard from "./pages/MemberDashboard";
import ElectionCorner from "./pages/ElectionCorner";
import AdminLogin from "./pages/AdminLogin";
import ContactUs from "./pages/ContactUs";
import FormViewer from "./pages/FormViewer";
import VisionMission from "./pages/VisionMission";
import Objectives from "./pages/Objectives";
import Reports from "./pages/Reports";
import ElectionNotice from "./pages/ElectionNotice";
import ElectionResults from "./pages/ElectionResults";
import HeadOffice from "./pages/HeadOffice";
import Feedback from "./pages/Feedback";
import NominationFormIII from "./pages/Election/NominationFormIII";
import TenderPortal from "./pages/tender/TenderPortal";
import TenderApply from "./pages/tender/TenderApply";
import Career from "./pages/Career";
import JobDetail from "./pages/JobDetail";
import JobApply from "./pages/JobApply";
import CIOPortal from "./pages/CIOPortal";
import Policies from "./pages/Policies";
import CIODashboard from "./pages/Admin/CIODashboard";
import ProcurementApplyPage from "./pages/procurement/ProcurementApplyPage";
import PmcEngineerApprovals from "./pages/pmc/PmcEngineerApprovals";
import ContractorDocuments from "./pages/tender/ContractorDocuments";
import PaymentStatus from "./pages/tender/PaymentStatus";
import LoaManager from "./pages/tender/LoaManager";
import ContractorConstructionPanel from "./pages/tender/ContractorConstructionPanel";
import EmployeeAttendanceKiosk from "./pages/hr/EmployeeAttendanceKiosk";
// Direct CEO module name intentionally differs from the legacy component so
// the active route cannot reuse an older cached dashboard bundle.
import NafedCeoDashboard from "./pages/nafed/ceo/NafedCeoDashboardDirect";
/* ================= ACCOUNTING ================= */

import AccountingLogin from "./pages/accounting/AccountingLogin";
import AccountingDashboard from "./pages/accounting/AccountingDashboard";
import AccountingSidebar from "./pages/accounting/AccountingSidebar";

import RegistrationVerify from "./pages/accounting/RegistrationVerify";
import TenderFeeEMD from "./pages/accounting/TenderFeeEMD";
import RABillVerify from "./pages/accounting/RABillVerify";
import CEOApprovalDesk from "./pages/accounting/CEOApprovalDesk";
import ContractorLedger from "./pages/accounting/ContractorLedger";
import AccountingReports from "./pages/accounting/AccountingReports";
import TenderFeeAccounting from "./pages/accounting/TenderFeeAccounting";
import RABillPaymentAllocation from "./pages/accounting/RABillPaymentAllocation";

/* ================= NAFED PORTAL IMPORTS ================= */

import NafedHomePage from "./pages/nafed/NafedHomePage";
import NafedAuthPage from "./pages/nafed/auth/NafedAuthPage";
import NafedContactPage from "./pages/nafed/NafedContactPage";


/* NAFED Head Office */
import NafedHeadLayout from "./pages/nafed/head/NafedHeadLayout";
import NafedHeadDashboard from "./pages/nafed/head/NafedHeadDashboard";
import HeadBranchApproval from "./pages/nafed/head/HeadBranchApproval";
import NafedComingSoon from "./pages/nafed/head/NafedComingSoon";

/* NAFED State Branch */
import StateBranchLayout from "./pages/nafed/branch/StateBranchLayout";
import StateBranchDashboard from "./pages/nafed/branch/StateBranchDashboard";
import BranchPmcApproval from "./pages/nafed/branch/BranchPmcApproval";
import BranchDistrictAllocation from "./pages/nafed/branch/BranchDistrictAllocation";
import BranchComingSoon from "./pages/nafed/branch/BranchComingSoon";

/* NAFED PMC */
import NafedPmcDashboard from "./pages/nafed/pmc/NafedPmcDashboard";

/* NAFED PACS */
import NafedPacsDashboard from "./pages/nafed/pacs/NafedPacsDashboard";
import NafedGodownApplyForm from "./pages/nafed/NafedGodownApplyForm";
import NafedPacsGodownApplyForm from "./pages/nafed/pacs/GodownApplyForm";
import NafedDistrictRegistrarDashboard from "./pages/nafed/district/NafedDistrictRegistrarDashboard.js";


// Project management pages
import ProjectsList from "./pages/ProjectsList";
import ProjectDetail from "./pages/ProjectDetail";

import GodownApplyForm from "./pages/pacs/GodownApplyForm";

// âœ… Society Act / Bye-laws Library (NEW)
import LegalLibrary from "./pages/legal/LegalLibrary";
import LegalDocViewer from "./pages/legal/LegalDocViewer";
import AdminLegalUpload from "./pages/legal/AdminLegalUpload";

// Protected Route utility
import ProtectedRoute from "./utils/ProtectedRoute";

// âœ… Admin Dashboards
import ApplicationsDashboard from "./pages/Admin/ApplicationsDashboard";
import MembersDashboard from "./pages/Admin/MembersDashboard";
import ProjectsDashboard from "./pages/Admin/ProjectsDashboard";
import MOUDashboard from "./pages/Admin/MOUDashboard";
import CareerDashboard from "./pages/Admin/CareerDashboard";

// âœ… Master Admin Dashboard (new)
import AdminMasterDashboard from "./pages/Admin/AdminMasterDashboard";

// Vendor / Farmer portals
import FarmerVendorSignup from "./pages/vendor/FarmerVendorSignup";
import FarmerVendorLogin from "./pages/vendor/FarmerVendorLogin";
import FarmerVendorDashboard from "./pages/vendor/FarmerVendorDashboard";
import MachineryBankFarmer from "./pages/farmer/MachineryBankFarmer";
import MachineryApplyForm from "./pages/farmer/MachineryApplyForm";

// âœ… Tender â€“ Contractor & Vendor
import ContractorDashboard from "./pages/tender/ContractorDashboard";
import VendorDashboard from "./pages/tender/VendorDashboard";
import ProjectProgress from "./pages/tender/ProjectProgress";
import AdminBoqUpload from "./pages/tender/AdminBoqUpload";
import RaBillGenerator from "./pages/tender/RaBillGenerator";
import DailyProgressPage from "./pages/tender/DailyProgressPage";

// âœ… PMC â€“ Daily Progress
import PmcDailyProgressReport from "./pages/pmc/PmcDailyProgressReport";
import PmcLogin from "./pages/pmc/PmcLogin";
import MemberLoginOTP from "./pages/MemberLoginOTP";


// âœ… Engineer (Tender side)
import EngineerDashboard from "./pages/tender/EngineerDashboard";
import EngineerRaBillGenerator from "./pages/tender/EngineerRaBillGenerator";
import GenerateLOA from "./pages/pmc/GenerateLOA";

// Office Subsidy Scheme
import OfficeSchemeApplyForm from "./pages/office-scheme/apply/OfficeSchemeApplyForm";
import OfficeSchemeDashboard from "./pages/office-scheme/dashboard/OfficeSchemeDashboard";
import HrDashboard from "./pages/hr/HrDashboard";






// âœ… Tender System
import AdminTenderDashboard from "./pages/tender/AdminTenderDashboard";
import LiveTenderList from "./pages/tender/LiveTenderList";
import VendorTenderStatus from "./pages/tender/VendorTenderStatus";
import TenderDetail from "./pages/tender/TenderDetail";

// ðŸ”¹ Contractor measurement sheet
import ContractorMeasurementSheetPage from "./pages/tender/ContractorMeasurementSheetPage";
import PmcEngineerRaBillsRegisterPane from "./pages/pmc/PmcEngineerRaBillsRegisterPane";
import NafedStateRegistrarDashboard from "./pages/nafed/stateRegistrar/NafedStateRegistrarDashboard.js";

// âœ… PMC
import PmcDashboard from "./pages/pmc/PmcDashboard";
import PmcFinalRaApproval from "./pages/pmc/PmcFinalRaApproval";
import EngineerMeasurementSheet from "./pages/pmc/EngineerMeasurementSheet";




// âœ… Stakeholder (Bank / Registrar / Agency) common portal
import AgencyPortal from "./pages/portal/AgencyPortal";
import StakeholderDashboard from "./pages/portal/StakeholderDashboard";

import FpoRegister from "./pages/fpo/FpoRegister";
import FpoLogin from "./pages/fpo/FpoLogin";
import FpoDashboard from "./pages/fpo/FpoDashboard";

import ProcurementPage from "./pages/ProcurementPage";

import FpoApprovalsAdmin from "./pages/Admin/FpoApprovalsAdmin";
import OutreachDashboard from "./pages/Admin/OutreachDashboard";




// âœ… Vendor guard (JS version)
import RequireVendor from "./utils/RequireVendor";
import WorkVendorPortal from "./pages/workflow/WorkVendorPortal";
import AdminWorkflowDashboard from "./pages/workflow/AdminWorkflowDashboard";
import WorkflowAdminLogin from "./pages/workflow/WorkflowAdminLogin";
import WorkflowAdminGate from "./components/WorkflowAdminGate";
import SchemeGrainStorage from "./pages/SchemeGrainStorage";

export default function AppRoutes() {
  return (
    <Routes>
      
     {/* ================= NAFED NATIONAL PORTAL ================= */}

{/* ================= NAFED PUBLIC PAGES ================= */}

<Route
  path="/nafed"
  element={<NafedHomePage />}
/>

<Route
  path="/nafed/login"
  element={<NafedAuthPage />}
/>

<Route
  path="/nafed/register"
  element={<NafedAuthPage />}
/>

{/* PACS New Application Form */}

<Route
  path="/nafed/apply-godown"
  element={<NafedPacsGodownApplyForm />}
/>

{/* PACS Dashboard */}
<Route
  path="/nafed/pacs"
  element={<NafedPacsDashboard />}
/>

{/* ================= NAFED HEAD OFFICE PORTAL ================= */}

<Route
  path="/nafed/head"
  element={<NafedHeadLayout />}
>
  <Route
    index
    element={<NafedHeadDashboard />}
  />

  <Route
    path="branch-approval"
    element={<HeadBranchApproval />}
  />

  <Route
    path="overview"
    element={<NafedComingSoon title="Overview" />}
  />

  <Route
    path="projects"
    element={<NafedComingSoon title="Projects" />}
  />

  <Route
    path="dpr"
    element={<NafedComingSoon title="DPR Management" />}
  />

  <Route
    path="tender"
    element={<NafedComingSoon title="Tender Management" />}
  />

  <Route
    path="loa"
    element={<NafedComingSoon title="LOA Management" />}
  />

  <Route
    path="ra-bill"
    element={<NafedComingSoon title="RA Bill Management" />}
  />

  <Route
    path="progress"
    element={<NafedComingSoon title="Progress Monitoring" />}
  />

  <Route
    path="states"
    element={<NafedComingSoon title="States" />}
  />

  <Route
    path="districts"
    element={<NafedComingSoon title="Districts" />}
  />

  <Route
    path="pacs"
    element={<NafedComingSoon title="PACS" />}
  />

  <Route
    path="pmc"
    element={<NafedComingSoon title="PMCs / Agencies" />}
  />

  <Route
    path="contractors"
    element={<NafedComingSoon title="Contractors" />}
  />

  <Route
    path="banks"
    element={<NafedComingSoon title="Banks" />}
  />

  <Route
    path="project-reports"
    element={<NafedComingSoon title="Project Reports" />}
  />

  <Route
    path="financial-reports"
    element={<NafedComingSoon title="Financial Reports" />}
  />

  <Route
    path="progress-reports"
    element={<NafedComingSoon title="Progress Reports" />}
  />

  <Route
    path="mis"
    element={<NafedComingSoon title="MIS Reports" />}
  />

  <Route
    path="power-bi"
    element={<NafedComingSoon title="Power BI Dashboard" />}
  />

  <Route
    path="users"
    element={<NafedComingSoon title="Users & Roles" />}
  />

  <Route
    path="notifications"
    element={<NafedComingSoon title="Notifications" />}
  />

  <Route
    path="audit"
    element={<NafedComingSoon title="Audit Logs" />}
  />

  <Route
    path="settings"
    element={<NafedComingSoon title="Settings" />}
  />

  {/* Invalid Head Office URL fallback */}
  <Route
    path="*"
    element={
      <Navigate
        to="/nafed/head"
        replace
      />
    }
  />
</Route>
<Route path="/nafed/contact" element={<NafedContactPage />} />

<Route path="/nafed/ceo" element={<NafedCeoDashboard />} />

{/* ================= NAFED STATE BRANCH PORTAL ================= */}

<Route
  path="/nafed/branch"
  element={<StateBranchLayout />}
>
  <Route
    index
    element={<StateBranchDashboard />}
  />

  <Route
    path="pmc-approval"
    element={<BranchPmcApproval />}
  />

  <Route
    path="district-allocation"
    element={<BranchDistrictAllocation />}
  />

  <Route
    path="projects"
    element={<BranchComingSoon title="Projects" />}
  />

  <Route
    path="pacs"
    element={<BranchComingSoon title="PACS Management" />}
  />

  <Route
    path="reports"
    element={<BranchComingSoon title="Reports" />}
  />

  {/* Invalid State Branch URL fallback */}
  <Route
    path="*"
    element={
      <Navigate
        to="/nafed/branch"
        replace
      />
    }
  />
</Route>

{/* ================= NAFED PMC PORTAL ================= */}

<Route
  path="/nafed/pmc"
  element={<NafedPmcDashboard />}
/>
<Route
  path="/nafed/state-registrar"
  element={<NafedStateRegistrarDashboard />}
/>

{/* District Registrar is intentionally outside AppLayout. This prevents the
    public website Navbar/Header from appearing above the secured dashboard. */}
<Route
  path="/nafed/district"
  element={<NafedDistrictRegistrarDashboard />}
/>

{/* ================= MAIN WEBSITE LAYOUT ================= */}

<Route element={<AppLayout />}>
  {/* Website Home Page */}
  <Route
    index
    element={<Home />}
  />
  

  {/* About Section */}
  <Route
    path="/about"
    element={<AboutUs />}
  />

  <Route
    path="/about/vision"
    element={<VisionMission />}
  />

  <Route
    path="/about/objectives"
    element={<Objectives />}
  />

  {/* Membership */}
  <Route
    path="/apply"
    element={<ApplyMembership />}
  />

  <Route
    path="/member-login"
    element={<MemberLogin />}
  />

  <Route
    path="/member-dashboard"
    element={<MemberDashboard />}
  />

  {/* Admin Master Dashboard */}
  <Route
    path="/admin/master-dashboard"
    element={
      <ProtectedRoute>
        <AdminMasterDashboard />
      </ProtectedRoute>
    }
  />

  {/* Baaki purane website routes iske niche rahenge */}
  {/* ================= ACCOUNTING ROUTES ================= */}

<Route
  path="/accounting-login"
  element={<AccountingLogin />}
/>

<Route
  path="/accounting"
  element={<AccountingDashboard />}
/>

<Route
  path="/accounting/registration"
  element={<RegistrationVerify />}
/>

<Route
  path="/accounting/tender-payments"
  element={<TenderFeeEMD />}
/>

<Route
  path="/accounting/ra-bills"
  element={<RABillVerify />}
/>

<Route
  path="/accounting/ceo-approval"
  element={<CEOApprovalDesk />}
/>

<Route
  path="/accounting/ledger"
  element={<ContractorLedger />}
/>
<Route
  path="/accounting/ra-payments"
  element={<RABillPaymentAllocation />}
/>

<Route
  path="/accounting/reports"
  element={<AccountingReports />}
/>
<Route path="/accounting/tender-fee" element={<TenderFeeAccounting />} />
        {/* Farmer / Machinery */}
        <Route
          path="/farmer/machinery/apply"
          element={<MachineryApplyForm />}
        />

        {/* Election */}
        <Route path="/election" element={<ElectionCorner />} />
        <Route path="/election/notices" element={<ElectionNotice />} />
        <Route path="/election/results" element={<ElectionResults />} />
        <Route path="/nomination-form-iii" element={<NominationFormIII />} />

        {/* âœ… FIX START: duplicate route fix - MemberLoginOTP moved to a unique path */}
        <Route path="/member-login-otp" element={<MemberLoginOTP />} />
        {/* âœ… FIX END */}

        {/* Contractor daily progress (old) */}
        <Route
          path="/tender/progress/:tenderId"
          element={<DailyProgressPage />}
        />

        {/* Admin Login */}
        <Route path="/admin-login" element={<AdminLogin />} />

                {/* âœ… Society Act / Bye-laws Library (NEW) */}
        <Route path="/library" element={<LegalLibrary />} />
        <Route path="/library/:docId" element={<LegalDocViewer />} />

        {/* âœ… Admin â€“ Upload Legal PDFs (NEW) */}
        <Route
          path="/admin/legal-upload"
          element={
            <ProtectedRoute>
              <AdminLegalUpload />
            </ProtectedRoute>
          }
        />

        {/* Reports */}
        <Route path="/admin-login/reports" element={<Reports />} />
        <Route
          path="/reports"
          element={<Navigate to="/admin-login/reports" replace />}
        />

        {/* Contact */}
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/contact/HeadOffice" element={<HeadOffice />} />
        <Route
          path="/contact/Headoffice"
          element={<Navigate to="/contact/HeadOffice" replace />}
        />
        <Route path="/contact/Feedback" element={<Feedback />} />

        {/* PMC Master Dashboard */}
        <Route path="/pmc/dashboard" element={<PmcDashboard />} />
        <Route path="/pmc/engineer-approvals" element={<PmcEngineerApprovals />} />
        <Route path="/pmc/login" element={<PmcLogin />} />
        <Route path="/admin/outreach" element={<OutreachDashboard />} />
    
<Route path="/procurement/apply" element={<ProcurementApplyPage />} />
{/* Existing accounting login is retained above. This unique alias preserves
    the second entry without creating a duplicate path. */}
<Route path="/accounting/login" element={<AccountingLogin />} />



        {/* Vendor / Dealer Portals */}
        <Route path="/vendor/signup" element={<FarmerVendorSignup />} />
        <Route path="/vendor/login" element={<FarmerVendorLogin />} />
        <Route path="/vendor/dashboard" element={<FarmerVendorDashboard />} />

        {/* FPO / Cooperative Portal */}
<Route path="/fpo/register" element={<FpoRegister />} />
<Route path="/fpo/login" element={<FpoLogin />} />
<Route path="/fpo/dashboard" element={<FpoDashboard />} />

{/* Admin FPO approvals */}
<Route path="/admin/fpo-approvals" element={<FpoApprovalsAdmin />} />
        {/* OLD alias */}
        <Route path="/machinery-bank" element={<MachineryBankFarmer />} />
        <Route
          path="/farmer/machinery-bank"
          element={<MachineryBankFarmer />}
        />
{/* Existing /accounting route is retained above. */}
<Route path="/accounting/dashboard" element={<AccountingDashboard />} />
        {/* Form Viewer */}
        <Route path="/form-preview/:formId" element={<FormViewer />} />

        {/* Workflow â€“ Vendor Portal */}
        <Route path="/workflow/vendors" element={<WorkVendorPortal />} />

        {/* Workflow â€“ Admin */}
        <Route path="/workflow/admin-login" element={<WorkflowAdminLogin />} />
        <Route
          path="/workflow/admin"
          element={
            <WorkflowAdminGate>
              <AdminWorkflowDashboard />
            </WorkflowAdminGate>
          }
        />
        <Route
        path="/pmc/engineer-ra-bills"
        element={<PmcEngineerRaBillsRegisterPane />}
      />

    

        {/* Tender BOQ Upload */}
        <Route
          path="/tender/admin/:tenderId/boq-upload"
          element={<AdminBoqUpload />}
        />

        {/* Contractor â€“ RA Bill */}
        <Route
          path="/tender/ra/:tenderId"
          element={<RaBillGenerator />}
        />

   <Route path="/tender/construction" element={<ContractorConstructionPanel />} />

        {/* PMC Final RA */}
        <Route
          path="/pmc/final-ra/:tenderId"
          element={<PmcFinalRaApproval />}
        />

        {/* Engineer Measurement (tender side) */}
        <Route
          path="/tender/engineer-measurement/:tenderId"
          element={<EngineerMeasurementSheet />}
        />
        <Route path="/pmc/engineer-measurement-sheet" element={<EngineerMeasurementSheet />} />
        

        {/* Engineer RA generator (tender side â€“ project dropdown) */}
        <Route
          path="/tender/engineer-ra"
          element={<EngineerRaBillGenerator />}
        />

        {/* Tender Public */}
        <Route path="/tender" element={<TenderPortal />} />
        <Route path="/tender/list" element={<LiveTenderList />} />
        <Route
          path="/tenders"
          element={<Navigate to="/tender/list" replace />}
        />
        <Route path="/tender/:id" element={<TenderDetail />} />

        <Route
          path="/vendor/status"
          element={
            <RequireVendor>
              <VendorTenderStatus />
            </RequireVendor>
          }
        />

        <Route path="/tender/loa/:tenderId" element={<LoaManager />} />
<Route path="/tender/documents/:tenderId" element={<ContractorDocuments />} />
<Route path="/tender/payments/:tenderId" element={<PaymentStatus />} />

<Route
  path="/society-office-apply"
  element={<OfficeSchemeApplyForm />}
/>
<Route path="/hr-dashboard" element={<HrDashboard />} />
<Route
  path="/employee-attendance"
  element={<EmployeeAttendanceKiosk />}
/>

<Route
  path="/office-scheme-dashboard"
  element={<OfficeSchemeDashboard />}
/>

<Route
  path="/admin/office-scheme-dashboard"
  element={<OfficeSchemeDashboard />}
/>
      

        {/* Tender Apply */}
        <Route
          path="/tender/apply"
          element={
            <RequireVendor>
              <TenderApply />
            </RequireVendor>
          }
        />
        <Route
          path="/tender/apply/:tenderId"
          element={
            <RequireVendor>
              <TenderApply />
            </RequireVendor>
          }
        />
        <Route path="/pmc/generate-loa" element={<GenerateLOA />} />


        {/* PMC Daily Progress Report */}
        <Route
          path="/pmc/daily-progress-report"
          element={<PmcDailyProgressReport />}
        />

        {/* â­ ENGINEER PORTAL â­ */}
        {/* Login + Register page */}
        <Route path="/tender/engineer" element={<EngineerDashboard />} />
        

        {/* Engineer dashboard (after login) */}
        <Route
          path="/tender/engineer/dashboard"
          element={<EngineerDashboard />}
        />

      

        {/* (Engineer measurement / RA routes already added above) */}

        {/* Projects */}
        <Route path="/projects" element={<ProjectsList />} />
        <Route path="/project/:id" element={<ProjectDetail />} />

        {/* Godown Apply */}
        <Route path="/apply-godown" element={<GodownApplyForm />} />

        {/* Contractor Dashboard */}
        <Route
          path="/tender/contractor"
          element={<ContractorDashboard />}
        />
      

        {/* CIO */}
        <Route path="/CIO" element={<CIOPortal />} />
        <Route path="/cio" element={<CIOPortal />} />
        <Route path="/admin/cio" element={<CIODashboard />} />
        <Route path="/policies" element={<Policies />} />

        {/* New ProjectProgress view uses its own path. The original
            /tender/progress/:tenderId route still opens DailyProgressPage. */}
        <Route
          path="/tender/project-progress/:tenderId"
          element={<ProjectProgress />}
        />

        {/* Contractor Measurement Sheet */}
        <Route
          path="/tender/measurement/:tenderId"
          element={<ContractorMeasurementSheetPage />}
        />

        {/* PMC â€“ Engineer Measurement (PMC view) */}
        <Route
          path="/pmc/measurement"
          element={<EngineerMeasurementSheet />}
        />

        {/* Careers */}
        <Route path="/career" element={<Career />} />
        <Route path="/career/:id" element={<JobDetail />} />
        <Route path="/career/:id/apply" element={<JobApply />} />

        {/* Vendor dashboard for tenders */}
        <Route path="/tender/dashboard" element={<VendorDashboard />} />

        {/* Admin Dashboards */}
        <Route
          path="/admin/applications"
          element={
            <ProtectedRoute>
              <ApplicationsDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/members"
          element={
            <ProtectedRoute>
              <MembersDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/projects"
          element={
            <ProtectedRoute>
              <ProjectsDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/mou"
          element={
            <ProtectedRoute>
              <MOUDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/careers"
          element={
            <ProtectedRoute>
              <CareerDashboard />
            </ProtectedRoute>
          }
        />

        {/* Tender Admin Dashboard */}
        <Route
          path="/admin/tender"
          element={
            <ProtectedRoute>
              <AdminTenderDashboard />
            </ProtectedRoute>
          }
        />

        {/* Stakeholder Portal */}
        <Route path="/agency/portal" element={<AgencyPortal />} />
        <Route
          path="/agency/dashboard"
          element={<StakeholderDashboard />}
        />
        <Route path="/scheme/grain-storage" element={<SchemeGrainStorage />} />

        <Route path="/procurement" element={<ProcurementPage />} />

        {/* Default fallback */}
        <Route path="*" element={<Home />} />
      </Route>
    </Routes>
  );
}
